export const invalidate = (client, key) =>
  client.invalidateQueries({
    predicate: (query) => query.queryKey[0] === key,
    exact: false,
  });
